import styled, { css } from "styled-components";

export const HoverStyle = css`
  content: "";
  position: absolute;
  bottom: -0.3rem;
  right: 0;
  left: 0;
  width: 0;
  height: 0.7px;
  background: ${({ theme }) => theme.backgroundColor.light};
  transition: 0.3s ease-in-out;
`;

export const Flex = css`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const StyledProjects = styled.section`
  position: relative;
  isolation: isolate;
  background: radial-gradient(
      circle at top left,
      rgba(255, 72, 251, 0.2),
      transparent 45%
    ),
    radial-gradient(circle at bottom right, rgba(110, 142, 255, 0.2), transparent 50%),
    ${({ theme }) => theme.backgroundColor.dark};
  color: ${({ theme }) => theme.color.light};
  padding: clamp(4rem, 7vw, 6rem) clamp(1.5rem, 6vw, 5rem) 4rem;
  overflow: hidden;
`;

export const ProjectsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 350px), 1fr));
  gap: 2rem;
  margin-top: 4rem;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;

  @media all and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const ProjectsMeta = styled.div`
  margin: 2rem auto 0;
  max-width: 720px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  color: ${({ theme }) => theme.color.lightGray};
  font-size: 0.95rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

export const FilterGroup = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.75rem;
`;

export const FilterButton = styled.button`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 999px;
  color: ${({ theme }) => theme.color.light};
  font-weight: 600;
  font-size: 0.9rem;
  padding: 0.45rem 1.25rem;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(6px);

  &[data-active="true"] {
    background: linear-gradient(120deg, #ff48fb, #8eaaff);
    color: #0a0515;
    border-color: transparent;
    box-shadow: 0 10px 30px rgba(255, 72, 251, 0.25);
  }
`;

export const ProjectsMessage = styled.p`
  text-align: center;
  margin-top: 2rem;
  font-size: 1rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.color.lightGray};

  &[data-variant="error"] {
    color: #ff6b6b;
  }
`;

export const ProjectImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 240px;
  overflow: hidden;
  background: #1a1a1a;
  
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 20px;
    background: #333;
    z-index: 10;
    display: flex;
    align-items: center;
    padding-left: 10px;
    background-image: radial-gradient(circle, #ff5f56 4px, transparent 5px),
                      radial-gradient(circle, #ffbd2e 4px, transparent 5px),
                      radial-gradient(circle, #27c93f 4px, transparent 5px);
    background-size: 15px 15px;
    background-position: 5px center, 25px center, 45px center;
    background-repeat: no-repeat;
  }
`;

export const ProjectImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
  transition: transform 0.5s ease;
`;

export const ProjectTransitionImage = styled.img`
  width: 100%;
  height: 100%;
  opacity: 0;
  object-fit: cover;
  object-position: top;
  position: absolute;
  top: 0;
  left: 0;
  transition: opacity 0.5s ease;
  z-index: 2;
`;

export const ProjectDetails = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  color: #fff;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.02) 0%, rgba(255, 255, 255, 0.05) 100%);
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  flex-grow: 1;
  transition: all 0.4s ease;
  z-index: 5;

  p {
    font-size: 0.95rem;
    color: ${({ theme }) => theme.color.lightGray};
    line-height: 1.6;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin: 0;
  }
`;

export const ProjectTitle = styled.h3`
  font-size: 1.4rem;
  font-weight: 700;
  margin: 0;
  background: linear-gradient(120deg, #fff, #aaa);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const LinkName = styled.span``;

export const ProjectCodeLink = styled.a`
  color: ${({ theme }) => theme.color.light};
  font-size: 0.8rem;
  font-weight: 600;
  ${Flex}
  padding: 0.5rem 1.2rem;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  text-transform: uppercase;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
  }
`;

export const ProjectLiveLink = styled.a`
  color: #0a0515;
  font-size: 0.8rem;
  font-weight: 700;
  ${Flex}
  padding: 0.5rem 1.2rem;
  border-radius: 8px;
  background: linear-gradient(120deg, #ff48fb, #8eaaff);
  border: none;
  text-transform: uppercase;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 72, 251, 0.2);

  &:hover {
    box-shadow: 0 8px 25px rgba(255, 72, 251, 0.4);
    transform: translateY(-2px);
    filter: brightness(1.1);
  }
`;

export const ProjectCard = styled.article`
  background: rgba(255, 255, 255, 0.03);
  border-radius: 1.5rem;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  height: 100%;

  @keyframes float {
    0% { transform: translateY(0px); }
    50% { transform: translateY(-5px); }
    100% { transform: translateY(0px); }
  }

  &:hover {
    transform: translateY(-10px);
    border-color: rgba(255, 72, 251, 0.3);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
    background: rgba(255, 255, 255, 0.05);
  }

  &:hover ${ProjectImage} {
    transform: scale(1.05);
  }

  &:hover ${ProjectTransitionImage} {
    opacity: 1;
  }

  @media all and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    border-radius: 1rem;
    &:hover {
      transform: none;
    }
  }
`;

export const ProjectBadge = styled.span`
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #ff48fb;
  background: rgba(255, 72, 251, 0.1);
  padding: 0.2rem 0.6rem;
  border-radius: 4px;
`;

export const ProjectMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const StackChip = styled.span`
  font-size: 0.7rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 999px;
  padding: 0.2rem 0.7rem;
`;

export const ProjectImpact = styled.p`
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);
  margin: 0.5rem 0 0;
`;

export const ProjectActions = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-top: auto;
`;

export const SectionHeading = styled.div`
  text-align: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${(props) => props.mb || "3rem"};
`;

export const SectionTitle = styled.h2`
  margin-bottom: 0.5rem;
  position: relative;
  font-size: 3rem;
  font-weight: 800;
  text-transform: capitalize;
  z-index: 1;
  color: ${(props) => (props.dark ? "#f2f2f2" : "#262637")};
  display: inline-block;

  &::after {
    position: absolute;
    content: "${(props) => props.number}";
    left: 5%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: ${(props) =>
      props.dark ? "rgba(29, 28, 28, 0.2)" : "rgba(0, 0, 0, 0.06)"};
    z-index: -1;
    font-size: 8rem;

    @media all and (max-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: 6rem;
    }
  }

  @media all and (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    font-size: 2.5rem;
  }
`;